<template>
  <footer class="bg-slate-950 border-t border-white/10 py-6 mt-auto">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row justify-between items-center gap-4">
        
        <!-- Branding -->
        <div class="flex items-center space-x-3 group">
          <div class="w-8 h-8 bg-gradient-to-br from-violet-500/20 to-indigo-600/20 rounded-lg flex items-center justify-center border border-white/5 group-hover:border-indigo-500/30 transition-colors">
            <svg class="w-4 h-4 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p class="text-sm font-bold text-white tracking-tight">SJP Voting System</p>
            <p class="text-[10px] text-slate-500 font-mono tracking-widest uppercase">Admin Portal</p>
          </div>
        </div>

        <!-- Links -->
        <div class="flex items-center gap-6">
          <a href="#" class="text-xs font-semibold text-slate-500 hover:text-indigo-400 transition-colors uppercase tracking-widest">Help</a>
          <router-link to="/admin/docs" class="text-xs font-semibold text-slate-500 hover:text-indigo-400 transition-colors uppercase tracking-widest">Documentation</router-link>
          <router-link v-if="authStore.isAuthenticated && authStore.isAdmin" to="/live" target="_blank" class="text-xs font-bold text-emerald-400 hover:text-emerald-300 transition-colors flex items-center gap-1.5 uppercase tracking-widest bg-emerald-500/10 px-3 py-1.5 rounded-md border border-emerald-500/20">
            <span class="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
            Projector Display
          </router-link>
        </div>

      </div>
    </div>
  </footer>
</template>

<script setup>
import { useAuthStore } from '@/stores/authStore'
const authStore = useAuthStore()
</script>
